import axios from 'axios';

export default {
    saveGeneral(id, form) {
        var fd = new FormData();
        for (let prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'workOrders') {
                    for (let i = 0; i < form.workOrders.length; i++) {
                        if (form.workOrders[i] instanceof File) {
                            fd.append(`workOrders`, form.workOrders[i]);
                        }
                        else {
                            fd.append(`oldAttachmentIds`, form.workOrders[i].id)
                        }
                    }
                } else {
                    if (form[prop] instanceof Date) {
                        fd.append(prop, form[prop].toISOString());
                    } else {
                        fd.append(prop, form[prop]);
                    }
                }
            }
        }
        if (id) {
            return axios.put(`/api/claims/${id}`, fd,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
        }

        return axios.post('/api/claims', fd,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    },
    saveSiteInfo(id, form, codes) {
        var request = Object.assign({}, form);
        request.repairCodes = codes.map(c => ({
            id: c.code.id,
            regularTime: c.regularTime,
            supplementaryRegularTime: c.supplementaryRegularTime,
            overTime: c.overTime,
            supplementaryOverTime: c.supplementaryOverTime,
            Comment: c.supplementaryComment
        }));
        return axios.put(`/api/claims/${id}/siteinfo`, request);
    },
    saveLaborTravel(id, form) {
        return axios.put(`/api/claims/${id}/labor`, form);
    },
    saveParts(id, parts, miscParts) {
        var request = {
            parts: parts.map(p => ({
                id: p.part.id,
                quantity: p.quantity
            })),
            miscParts: miscParts.map(p => ({
                name: p.part.name,
                price: p.part.price,
                extendedPrice: p.part.extendedPrice,
                quantity: p.quantity
            }))
        };
        return axios.put(`/api/claims/${id}/parts`, request);
    },
    saveTotal(id, form, claimId) {
        form.isNewClaim = typeof claimId == 'undefined' || claimId == null;
        return axios.put(`/api/claims/${id}/totals`, form);
    },
    publishClaim(id) {
        return axios.post(`/api/claims/${id}/publish`);
    },
    getRmaNumber() {
        return axios.get('/api/rma/getRmaNumber');
    },
    processClaim(id) {
        return axios.post(`/api/claims/${id}/process`);
    },
    sendRmaFormLink(claimId) {
        var data = { claimId };
        return axios.post(`/api/rma/sendLinkToRmaCreation`, data);
    },
    saveRma(form) {

        var data = {
           attnId: form.attn,
           serviceTicket: { ...form.serviceTicket, rmaId: form.id, raisedOn: form.serviceTicket.raisedOn },
            serviceCompany: { ...form.serviceCompany },
            serviceTicketId: form.serviceTicketId,
            serviceCompanyId: form.serviceCompanyId,
            claimId: form.claimId,
            shippingMethod: form.shippingMethod,
            countryOfOrigin: form.countryOfOrigin,
            serviceTicketNumber: form.serviceTicketNumber,
            invoiceNumber: form.invoiceNumber,
            claimNumber: form.claimNumber,
            id: form.id,
            attns: [],
            parts: form.parts,
            claimStatus: form.claimStatus,
            rmaDate: form.rmaDate,
            comment: form.comment,
            reason: form.reason
        };
        return axios.post(`/api/rma/saveRma`, data);
    },
    async getTrackingInfo(trackNumber) {
        var result = await axios.post('/api/rma/getTrackingInfo', { trackNumber });
        return result;
    },
    submitComment(id, form) {
        var fd = new FormData();
        for (let prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (let i = 0; i < form.attachments.length; i++) {
                        if (form.attachments[i] instanceof File) {
                            fd.append(`attachments`, form.attachments[i]);
                        }
                    }
                } else {
                    if (form[prop] != null) {
                        fd.append(prop, form[prop]);
                    }
                }
            }
        }
        return axios.post(`/api/claims/${id}/comments`, fd,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    },
    deleteClaim(id) {
        return axios.delete(`/api/claims/${id}`);
    },
    getClaims(page, filter, sorting) {
        return axios.get('/api/claims',
            {
                params: {
                    page: page,
                    q: filter.text,
                    raisedBy: filter.RaisedBy,
                    active: filter.active,
                    status: filter.status,
                    dateFrom: filter.dateFrom,
                    dateTo: filter.dateTo,
                    sortBy: sorting.sortBy,
                    sortOrder: sorting.sortOrder
                }
            });
    },
    getClaim(id) {
        return axios.get(`/api/claims/${id}`);
    },
    getClaimPreview(id) {
        return axios.get(`/api/claims/${id}/preview`);
    },
    getRepairCodes(productId, text) {
        return axios.get(`/api/resolutioncodes/lookup/${productId}`,
            {
                params: {
                    q: text,
                    details: true
                }
            });
    },
    getParts(term, serviceCompanyId, productId) {
        return axios.get('/api/parts/lookup',
            {
                params: {
                    term: term,
                    serviceCompanyId: serviceCompanyId,
                    productId: productId,
                    unavailableForClaims: true
                }
            });
    },
    validateServiceTicketNumber(number) {
        return axios.get(`/api/claims/validateServiceTicketNumber`,
            {
                params: {
                    number: number
                }
            });
    },
    validateInvoiceNumber(number, claimId) {
        return axios.get(`/api/claims/validateinvoice`,
            {
                params: {
                    number: number,
                    claimId: claimId
                }
            });
    },
    validateSerialNumber(number, product, coverage, is90Days) {
        return axios.get(`/api/claims/validateserial`,
            {
                params: {
                    number: number,
                    productId: product,
                    serviceCoverage: coverage,
                    is90DaysWarranty: is90Days
                }
            }).then(response => {
                return response.data;
            });
    },
    printClaim(id) {
        return axios.get(`/api/claims/${id}/print`);
    },
    printRma(id) {
        return axios.get(`/api/rma/${id}/print`);
    },
    getCategories() {
        return axios.get('/api/dashboard/categories/claims');
    },
    getPartById(id, serviceCompanyId, isNotWarrantyClaim) {
        return axios.get(`/api/parts/${id}/${serviceCompanyId}/${isNotWarrantyClaim}/dashboard`);
    },
    changeStatusOfClaim(id, claimStatus) {
        return axios.post(`/api/claims/${id}/${claimStatus}`);
    },
    loadComments(id) {
        return axios.get(`/api/claims/${id}/comments`);
    },
    download(url) {
        return axios.download(url);
    },
    sendEmailToReviewer(id, reviewerId) {
        return axios.get(`/api/claims/${id}/sendEmail/${reviewerId}`);
    },
    exportView(page, filter, sorting) {
        var params = {
            page: page,
            q: filter.text,
            raisedBy: filter.RaisedBy,
            active: filter.active,
            status: filter.status,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return axios.download('/api/claims/export', params);
    }
};


// WEBPACK FOOTER //
// ./ClientApp/app/claims/api.js